import Brands from './BrandImages'

export default function useBrand(theme: string) {
  const { [theme]: _, ...availableBrands } = Brands

  return {
    selectedBrand: Brands[theme],
    availableBrands,
  }
}
